export const LogoData = [
  {
    id: "1",
    imgLink:
      "https://brandlogos.net/wp-content/uploads/2022/04/wipro-logo-brandlogos.net_.png",
    altText: "company_logo",
  },
  {
    id: "2",
    imgLink: "https://iconape.com/wp-content/files/au/350989/svg/350989.svg",
    altText: "company_logo",
  },
  {
    id: "3",
    imgLink:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Tech_Mahindra_New_Logo.svg/1920px-Tech_Mahindra_New_Logo.svg.png",
    altText: "company_logo",
  },
  {
    id: "4",
    imgLink:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Walmart_logo.svg/1920px-Walmart_logo.svg.png",
    altText: "company_logo",
  },
  {
    id: "5",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218956/Client-logo/planetspark_logo_li6ybb.png",
    altText: "company_logo",
  },
  {
    id: "6",
    imgLink:
      "https://www.adani.com/businesses/-/media/8614C9E10D4A4EC3993153E0208322ED.ashx",
    altText: "company_logo",
  },
  {
    id: "7",
    imgLink:
      "https://www.tcs.com/content/dam/tcs/images/Newtcslogo/tcs-logo-tata-blue-1x-dec2021.png",
    altText: "company_logo",
  },
  {
    id: "8",
    imgLink:
      "https://res.cloudinary.com/daxilgrvn/image/upload/c_scale,h_1200,q_100,w_2400/v1658382806/T_P%20Site/regular-removebg-preview_ubarza.png",
    altText: "company_logo",
  },
  {
    id: "9",
    imgLink:
      "https://upload.wikimedia.org/wikipedia/en/6/64/Practo_new_logo.png",
    altText: "company_logo",
  },
  {
    id: "10",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218956/Client-logo/NIIT_logo_c3x2jv.png",
    altText: "company_logo",
  },
  {
    id: "11",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218955/Client-logo/Nuclei_logo_tz6fpx.png",
    altText: "company_logo",
  },
  {
    id: "12",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218955/Client-logo/nagarro_logo_vustw8.png",
    altText: "company_logo",
  },
  {
    id: "13",
    imgLink:
      "https://upload.wikimedia.org/wikipedia/en/d/d5/Myntra_logo.png?20210130000727",
    altText: "company_logo",
  },
  {
    id: "14",
    imgLink:
      "https://cdn-images-1.medium.com/max/320/1*0LICgnFoGNpbOcptP2IUTQ@2x.png",
    altText: "company_logo",
  },
  {
    id: "15",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218955/Client-logo/Lowes_Companies_Logo_vsw08c.png",
    altText: "company_logo",
  },
  {
    id: "16",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218955/Client-logo/microsoft_logo_bpxmjm.png",
    altText: "company_logo",
  },
  {
    id: "17",
    imgLink:
      "https://corpwebstorage.blob.core.windows.net/media/46702/logo.png",
    altText: "company_logo",
  },
  {
    id: "18",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218954/Client-logo/juspay_logo_yx89w8.png",
    altText: "company_logo",
  },
  {
    id: "19",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218954/Client-logo/Indiamart_logo_swaovg.png",
    altText: "company_logo",
  },
  {
    id: "20",
    imgLink: "https://www.jkcement.com/frontTheme/img/jkcemet-logo.png",
    altText: "company_logo",
  },
  {
    id: "21",
    imgLink:
      "https://upload.wikimedia.org/wikipedia/commons/6/6a/Jaro_Education_Logo.png?20160929072611",
    altText: "company_logo",
  },
  {
    id: "22",
    imgLink:
      "https://intellipaat.com/academy/wp-content/themes/wplms-college/images/intellipaat_logo.svg",
    altText: "company_logo",
  },
  {
    id: "23",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218954/Client-logo/Infosys_logo_jxsvmr.png",
    altText: "company_logo",
  },
  {
    id: "24",
    imgLink:
      "https://1000logos.net/wp-content/uploads/2021/05/Ericsson-logo.png",
    altText: "company_logo",
  },
  {
    id: "25",
    imgLink: "https://www.hummingwave.com/images/logo.png",
    altText: "company_logo",
  },
  {
    id: "26",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218953/Client-logo/HCL_Technologies_logo_a1kiow.png",
    altText: "company_logo",
  },
  {
    id: "27",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218953/Client-logo/GlobalLogic_logo_bpffuq.png",
    altText: "company_logo",
  },
  {
    id: "28",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218953/Client-logo/hexaview_logo_i5dinx.png",
    altText: "company_logo",
  },
  {
    id: "29",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218953/Client-logo/Extramarks_Logo_uptncz.jpg",
    altText: "company_logo",
  },
  {
    id: "30",
    imgLink: "https://www.delhivery.com/wp-content/uploads/2021/06/logo.jpg",
    altText: "company_logo",
  },
  {
    id: "31",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218952/Client-logo/de_shaw_logo_s1cisj.jpg",
    altText: "company_logo",
  },
  {
    id: "32",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218952/Client-logo/Dentsu_logo_cyirvw.png",
    altText: "company_logo",
  },
  {
    id: "33",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218952/Client-logo/Coforge-Logo_k4hfyb.png",
    altText: "company_logo",
  },
  {
    id: "34",
    imgLink:
      "https://assets.scaler.com/assets/scaler/svg/scaler-logo-new-15cddca2e0196e677600f6671b42a288bdc89c398adc29fe82b7441503c4b129.svg.gz",
    altText: "company_logo",
  },
  {
    id: "35",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218952/Client-logo/cognizant_logo_fjcfox.jpg",
    altText: "company_logo",
  },
  {
    id: "36",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218952/Client-logo/Capgemini_logo_i0ina8.png",
    altText: "company_logo",
  },
  {
    id: "37",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218952/Client-logo/Aditya_Birla_Group_Logo_a1tqgn.png",
    altText: "company_logo",
  },
  {
    id: "38",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218951/Client-logo/amazon_logo_yb1kpm.png",
    altText: "company_logo",
  },
  {
    id: "39",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218951/Client-logo/BNY_Mellon_logo_yuuwmq.png",
    altText: "company_logo",
  },
  {
    id: "40",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218951/Client-logo/appirio_logo_hj3tkc.jpg",
    altText: "company_logo",
  },
  {
    id: "41",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218951/Client-logo/BYJU_S_logo_upmbnb.png",
    altText: "company_logo",
  },
  {
    id: "42",
    imgLink:
      "https://res.cloudinary.com/vaish1101/image/upload/v1658218951/Client-logo/Accenture_logo_qxznbt.png",
    altText: "company_logo",
  },
  {
    id: "43",
    imgLink:
      "https://res.cloudinary.com/daxilgrvn/image/upload/v1675365185/T_P%20Site/logo_n2ltza.png",
    altText: "company_logo",
  },
  {
    id: "44",
    imgLink:
      "https://assetscdn1.paytm.com/images/catalog/category/5165/paytm_logo.png",
    altText: "company_logo",
  },
  {
    id: "45",
    imgLink:
      "https://newgensoft.com/wp-content/themes/newgensoftware/images/Newgen.logo.png",
    altText: "company_logo",
  },
  {
    id: "46",
    imgLink: "https://www.step2gen.com/WebsiteAssets/assets/images/logo.png",
    altText: "company_logo",
  },
  {
    id: "47",
    imgLink: "https://shop.siyaram.com/images/Siyaram-Logo.png",
    altText: "company_logo",
  },
  {
    id: "48",
    imgLink:
      "https://res.cloudinary.com/daxilgrvn/image/upload/v1675364631/T_P%20Site/cropped-footer-logo_xlhmgz.webp",
    altText: "company_logo",
  },
  {
    id: "49",
    imgLink: "https://www.digicommsemi.com/images/logo.png",
    altText: "company_logo",
  },
  {
    id: "50",
    imgLink: "https://www.codeyoung.com/_nuxt/img/codeyoung-logo.4c8144c.svg",
    altText: "company_logo",
  },
  {
    id: "51",
    imgLink:
      "https://www.pinclick.com/pinclick/images/PinClick%20Full%20Colour.svg",
    altText: "company_logo",
  },
  {
    id: "52",
    imgLink: "https://download.logo.wine/logo/Verifone/Verifone-Logo.wine.png",
    altText: "company_logo",
  },
  {
    id: "53",
    imgLink: "https://mma.prnewswire.com/media/1654428/logo.jpg?p=facebook",
    altText: "company_logo",
  },
  {
    id: "54",
    imgLink:
      "https://res.cloudinary.com/daxilgrvn/image/upload/v1658397189/T_P%20Site/colored_medium_1_f5kzrk.png",
    altText: "company_logo",
  },
  {
    id: "55",
    imgLink: "https://www.prismanmolrishtey.com/images/prismlogo.png",
    altText: "company_logo",
  },
  {
    id: "56",
    imgLink:
      "https://d2kh7o38xye1vj.cloudfront.net/wp-content/uploads/2018/08/SR-logo.png",
    altText: "company_logo",
  },
  {
    id: "57",
    imgLink:
      "https://res.cloudinary.com/daxilgrvn/image/upload/v1658397073/T_P%20Site/Learning-Routes-logo-e1622515029525_pfzpd1.png",
    altText: "company_logo",
  },
  {
    id: "58",
    imgLink:
      "https://download.logo.wine/logo/Hexaware_Technologies/Hexaware_Technologies-Logo.wine.png",
    altText: "company_logo",
  },
  {
    id: "59",
    imgLink:
      "https://dev.cedcoss.com/wordpress/wp-content/uploads/2020/09/Cedcoss-Logo-Edited-HQD-27-June-2-1.png",
    altText: "company_logo",
  },
  {
    id: "60",
    imgLink:
      "https://clearwateranalytics.com/wp-content/uploads/2021/07/clearwater-logo.svg",
    altText: "company_logo",
  },
  {
    id: "61",
    imgLink:
      "https://upload.wikimedia.org/wikipedia/en/thumb/8/8b/Bharat_Electronics_logo.svg/1920px-Bharat_Electronics_logo.svg.png",
    altText: "company_logo",
  },
  {
    id: "62",
    imgLink:
      "https://1000logos.net/wp-content/uploads/2020/06/MG-Logo-1952.png",
    altText: "company_logo",
  },
  {
    id: "63",
    imgLink:
      "https://www.biopetroclean.co.in/wp-content/uploads/2020/11/bpc-logo.png",
    altText: "company_logo",
  },
  {
    id: "64",
    imgLink:
      "https://seekvectorlogo.com/wp-content/uploads/2018/01/escorts-group-vector-logo.png",
    altText: "company_logo",
  },
  {
    id: "65",
    imgLink:
      "https://res.cloudinary.com/daxilgrvn/image/upload/v1675364793/T_P%20Site/Revature-768x768_dlcccd.webp",
    altText: "company_logo",
  },
  {
    id: "66",
    imgLink:
      "https://res.cloudinary.com/daxilgrvn/image/upload/v1675364858/T_P%20Site/corporate-footer-logo_zahwhx.svg",
    altText: "company_logo",
  },
  {
    id: "67",
    imgLink:
      "https://upload.wikimedia.org/wikipedia/en/thumb/c/cc/Vodafone_2017_logo.svg/1920px-Vodafone_2017_logo.svg.png",
    altText: "company_logo",
  },
  {
    id: "68",
    imgLink:
      "https://res.cloudinary.com/daxilgrvn/image/upload/v1675364968/T_P%20Site/Reliance_Jio_Logo__October_2015_s0huyi.svg",
    altText: "company_logo",
  },
  {
    id: "69",
    imgLink:
      "http://biztechindia.com/wp-content/uploads/2017/06/chaipoint-tea.png",
    altText: "company_logo",
  },
  {
    id: "70",
    imgLink: "https://www.pepcoding.com/images/logo.png",
    altText: "company_logo",
  },
  {
    id: "72",
    imgLink: "https://cucet.cuchd.in/new-assets/images/cu-logo.png",
    altText: "company_logo",
  },
  {
    id: "73",
    imgLink:
      "https://res.cloudinary.com/daxilgrvn/image/upload/v1658401911/T_P%20Site/pngegg_g36ooc.png",
    altText: "company_logo",
  },
  {
    id: "74",
    imgLink: "https://www.dltlabs.com/assets/images/DLT-logo-std.svg",
    altText: "company_logo",
  },
  {
    id: "75",
    imgLink:
      "https://jupiter.money/assets/images/header-white.svg?v=5dee553127",
    altText: "company_logo",
  },
  {
    id: "76",
    imgLink: "https://railtech.co.in/images1/logo1.png",
    altText: "company_logo",
  },
  {
    id: "77",
    imgLink: "https://rxlogix.bamboohr.com/jobs/share_image/28",
    altText: "company_logo",
  },
  {
    id: "78",
    imgLink:
      "https://www.qsstechnosoft.com/wp-content/themes/qss/assets/img/logo-new.png",
    altText: "company_logo",
  },
  {
    id: "79",
    imgLink:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Deloitte.svg/1920px-Deloitte.svg.png",
    altText: "company_logo",
  },
  {
    id: "80",
    imgLink:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/ServiceNow_logo.svg/1920px-ServiceNow_logo.svg.png",
    altText: "company_logo",
  },
  {
    id: "81",
    imgLink: "https://bigohtech.com/wp-content/uploads/2022/12/logo-c.png",
    altText: "company_logo",
  },
  {
    id: "82",
    imgLink:
      "https://images.samsung.com/is/image/samsung/assets/in/about-us/brand/logo/pc/300_186_1.png?$568_N_PNG$",
    altText: "company_logo",
  },
  {
    id: "83",
    imgLink:
      "https://upload.wikimedia.org/wikipedia/en/thumb/3/39/Kotak_Mahindra_Group_logo.svg/330px-Kotak_Mahindra_Group_logo.svg.png",
    altText: "company_logo",
  },
  {
    id: "84",
    imgLink:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/ICICI_Bank_Logo.svg/1920px-ICICI_Bank_Logo.svg.png",
    altText: "company_logo",
  },
  {
    id: "85",
    imgLink:
      "https://d1.awsstatic.com/gcrp_adverbTechnologies_03282022.4e0f935e4bb413543057504676b4eba9e018b9cd.png",
    altText: "company_logo",
  },
  {
    id: "86",
    imgLink:
      "https://upload.wikimedia.org/wikipedia/commons/a/a2/MakeMyTrip_Logo.png",
    altText: "company_logo",
  },
];
